import { render } from "./PerformanceSentimentByChannel.vue?vue&type=template&id=93367350&scoped=true"
import script from "./PerformanceSentimentByChannel.vue?vue&type=script&lang=js"
export * from "./PerformanceSentimentByChannel.vue?vue&type=script&lang=js"

import "./PerformanceSentimentByChannel.vue?vue&type=style&index=0&id=93367350&lang=scss"
import "./PerformanceSentimentByChannel.vue?vue&type=style&index=1&id=93367350&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93367350"]])

export default __exports__